import styled from 'styled-components'

import Button from '../Button/Button'

const MobileButtonGroup = styled.div`
  padding: ${props => props.theme.gutter}px 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;

  ${Button} {
    padding: 0 10px;
    height: 40px;
    border-radius: 20px;
    border: 0;
  }

  @media (min-width: 768px) {
    display: none;
  }
`

export default MobileButtonGroup
